
import About from "../components/About";
import {
    createPostalAddress,
    createSchemaHead,
    getAboutContactData,
    getCanonicalUrl,
    getSiteName,
} from "../utils/schema";
export default {
    components: {About},
    async asyncData({ $axios, route, error }) {
        try {
            const res = await $axios.get('api/v1/static-pages/' + route.name);

            return {
                page: res.data.data,
            }
        }
        catch (e) {
            error({ statusCode: 404, message: 'Page not found' });
        }
    },
    head() {
        const canonical = getCanonicalUrl(this);
        const contactData = getAboutContactData(this);
        const organizationId = `${canonical}#organization`;
        const contactPoints = (contactData.phones || []).map((phone) => ({
            '@type': 'ContactPoint',
            telephone: phone,
            email: contactData.email,
            contactType: contactData.contactType,
            availableLanguage: contactData.availableLanguage || ['ru'],
            areaServed: this.$config.siteCountry === 'kz' ? 'KZ' : 'RU',
            hoursAvailable: contactData.openingHours
                ? contactData.openingHours.map((opens) => ({
                    '@type': 'OpeningHoursSpecification',
                    opens: opens.split(' ')[1].split('-')[0],
                    closes: opens.split(' ')[1].split('-')[1],
                    dayOfWeek: [
                        'https://schema.org/Monday',
                        'https://schema.org/Tuesday',
                        'https://schema.org/Wednesday',
                        'https://schema.org/Thursday',
                        'https://schema.org/Friday',
                    ],
                }))
                : undefined,
        }));
        const schemaHead = createSchemaHead([
            {
                '@type': 'AboutPage',
                '@id': `${canonical}#webpage`,
                url: canonical,
                name: this.page.seo_title ? this.page.seo_title : this.page.name,
                description: this.page.seo_description || undefined,
                mainEntity: {
                    '@id': organizationId,
                },
            },
            {
                '@type': 'Organization',
                '@id': organizationId,
                name: contactData.organizationName || getSiteName(this),
                url: canonical,
                email: contactData.email,
                telephone: contactData.phones && contactData.phones.length === 1 ? contactData.phones[0] : undefined,
                contactPoint: contactPoints.length ? contactPoints : undefined,
                address: createPostalAddress(contactData.legalAddress),
                location: contactData.pickupAddress ? {
                    '@type': 'Place',
                    address: createPostalAddress(contactData.pickupAddress),
                } : undefined,
            },
        ], 'schema-org-about');

        return {
            title: this.page.seo_title ? this.page.seo_title : this.page.name,
            meta: [
                { hid: 'description', name: 'description', content: this.page.seo_description },
                { hid: 'keywords', name: 'keywords', content: '' },
            ],
            link: [
                { hid: 'canonical', rel: 'canonical', href: canonical },
            ],
            ...schemaHead,
        }
    },
    data() {
        return {

        }
    },
    methods: {

    },
}
